import {
  SUBSCRIBE,
  CANCEL_SUBSCRIPTION,
  RENEW_SUBSCRIPTION
} from '../graphql/queries/BillingQueries'
import { apolloClient } from '../graphql/apollo'

export const subscribe = async (input = {}) => {
  try {
    const { data } = await apolloClient.mutate({
      mutation: SUBSCRIBE,
      variables: { input }
    })
    return data.subscribe.billingPlan
  } catch (e) {
    console.log(e)
    throw e
  }
}

export const cancelSubscription = async (input = {}) => {
  try {
    const { data } = await apolloClient.mutate({
      mutation: CANCEL_SUBSCRIPTION,
      variables: { input }
    })
    return data.cancelSubscription.billingPlan
  } catch (e) {
    console.log(e)
    throw e
  }
}

export const renewSubscription = async (input = {}) => {
  try {
    const { data } = await apolloClient.mutate({
      mutation: RENEW_SUBSCRIPTION,
      variables: { input }
    })
    return data.renewSubscription.billingPlan
  } catch (e) {
    console.log(e)
    throw e
  }
}
